import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { flexRender } from '@tanstack/react-table'
import React, { useMemo } from 'react'

const MyDataTable = ({ table }) => {
  const visibleLength = useMemo(
    () =>
      table?.getAllLeafColumns()?.filter((column) => column.getIsVisible())
        ?.length,
    [table],
  )
  return (
    <Table>
      <TableHeader>
        {table.getHeaderGroups().map((headerGroup) => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => {
              return (
                <TableHead key={header.id} colSpan={header.colSpan}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                </TableHead>
              )
            })}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {table?.getRowModel()?.rows?.length ? (
          table.getRowModel().rows.map((row) => (
            <TableRow
              key={row.id}
              className="data-[state=selected]:border-primary"
              onClick={(e) => {
                if (!row.getCanSelect()) return
                // 避免点按钮/菜单/复选框时误触整行选中
                if (
                  e.target.closest(
                    'button, a, input, label, [role="button"], [role="menuitem"], [role="checkbox"]',
                  )
                ) {
                  return
                }
                row.toggleSelected(!row.getIsSelected())
              }}
              data-state={row.getIsSelected() && 'selected'}
            >
              {row.getVisibleCells().map((cell) => (
                <TableCell key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={visibleLength} className="h-24 text-center">
              No results.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}

export default MyDataTable
